import { FeatureDefinitions } from "../../models/FeatureDefinitions"
import { EFeatureCategory } from "../../types/EFeatureCategory"

//If category has no features to show, it will not be display. This is the case for pop-ups and landing pages for many resellers.
export function categoryHasVisibleFeatures(category: EFeatureCategory, configFeatures: string[] = []) {
    return Object.keys(FeatureDefinitions).some((feature) => {
        const def = FeatureDefinitions[feature]
        const isInCategory = def?.category === category
        const isVisible = !def?.brandSpecific || configFeatures.includes(feature)
        const isNotDisplayCardOnly = !def?.displayCardOnly
        return isInCategory && isVisible && isNotDisplayCardOnly
    })
}
